import { global } from '@/endpoint.flexigo';
import { server } from '@/endpoints/server';
import Repository from './repository';

const client = new Repository();

export default {
  async listAll() {
    const r = await client.get(global.listAll);
    return r;
  },
  async reverseGeocode(lat, lng) {
    const r = await client.get(global.reverseGeocode.replace(':lat', lat).replace(':lng', lng));
    return r;
  },
  async getCompanySettings() {
    const r = await client.get(global.getCompanySettings);
    return r;
  },
  async getServerTimezone() {
    const r = await client.get(server.serverTimezone);
    return r;
  },
  async getCompanyModules() {
    const r = await client.get(`${global.getCompanySettings}/modules`);
    return r;
  },
};
